import React, { useState } from "react";
import {
  Create,
  SaveButton,
  SimpleForm,
  Toolbar,
  TopToolbar,
  useNotify,
} from "react-admin";
import { BackButton } from "../../../components/common/BackButton";
import { ForceTitle } from "../../../components/common/ForceTitle";
import { deepRedirect, getBackPath } from "../../../utils/utils";
import { EventTypeForm } from "./EventTypeForm";
import { logError } from "../../../utils/appUtils";
import { usHolidays } from "../../../utils/constants";
import {
  encodeScheduleHolidaysForMutation,
  initialDecodedScheduleForEventTypeForm,
} from "../../../utils/holidayRules";

const CreateActions = (props) => {
  const { backPath } = props;
  return (
    <TopToolbar>
      <BackButton {...props} backPath={backPath} />
    </TopToolbar>
  );
};

const CreateToolbar = (props) => (
  <Toolbar {...props}>
    <ValidateSaveButton {...props} />
  </Toolbar>
);

export const EventTypeCreate = (props) => {
  const { history } = props;
  const backPath = getBackPath(props);

  const scheduleCopy = initialDecodedScheduleForEventTypeForm(
    window.appUser?.reloadYard?.schedule,
    usHolidays,
  );

  const initValues = {
    active: "true",
    groups: window.appUser.reloadYard.groups,
    reloadYardId: window.appUser.reloadYardId,
    schedule: scheduleCopy,
    bufferTime: 0,
    duration: 30,
    areaId: "",
    numberOfResources: 1,
  };

  return (
    <Create
      {...props}
      title={<ForceTitle title="New Event Type" />}
      actions={<CreateActions backPath={backPath} history={history} />}
    >
      <SimpleForm
        variant="outlined"
        submitOnEnter={false}
        initialValues={initValues}
        toolbar={
          <CreateToolbar {...props} backPath={backPath} history={history} />
        }
      >
        <EventTypeForm {...props} />
      </SimpleForm>
    </Create>
  );
};

export const ValidateSaveButton = (props) => {
  const notify = useNotify();
  const [saving, setSaving] = useState(false);
  const { backPath, history } = props;

  const transform = (data) => {
    data.assetTypeId = data.assetTypeId ? data.assetTypeId : "";
    delete data.assetType;
    encodeScheduleHolidaysForMutation(data);
    return data;
  };

  const onSuccess = async ({ data }) => {
    notify(`Event created successfully.`);
    setSaving(false);
    deepRedirect(history, backPath);
  };

  const onFailure = (error) => {
    setSaving(false);
    logError("EventTypeCreate:ValidateSaveButton:onFailure", error, notify);
  };

  return (
    <SaveButton
      label="Save"
      disabled={saving}
      submitOnEnter={false}
      undoable={false}
      transform={transform}
      onSuccess={onSuccess}
      onFailure={onFailure}
      {...props}
    />
  );
};
